export enum ErrorMessages {
  OPERATION_FAILED = 'Operation Failed',
  FORM_ERROR = 'Please check the form for errors',
  CHANGES_SAVED = 'Changes Saved',
  ENTRY_DELETED = 'Entry Deleted',
}
